<template>
  <!-- UserManage -->
  <el-tab-pane label="UserManage">
    <div>
      <div class="row">
        <div class="col-sm-12">
          <el-card>
            <h4 style="color: #3b291d">UserManage</h4>
            <!-- Start search part -->
            <div class="row">
              <div class="col-sm-2">
                <base-input label="Name">
                  <el-input placeholder="name" clearable style="
                      border: 1px solid hsl(0, 0%, 5%);
                      border-radius: 5px;
                      --el-input-focus-border-color: #f0f3f7;
                    " v-model="searchKey.name"></el-input>
                </base-input>
              </div>
              <div class="col-sm-2">
                <base-input label="DepartmentName" :clearable="true">
                  <el-select v-model="searchKey.departmentName" class="select-primary" filterable size="large"
                    placeholder="DepartmentName">
                    <el-option label="All" value=""> </el-option>
                    <el-option label="Billboard" value="Billboard"> </el-option>
                    <el-option label="Bus" value="Bus"> </el-option>
                  </el-select>
                </base-input>
              </div>
              <div class="col-sm-2">
                <base-input label="Status" :clearable="true">
                  <el-select v-model="searchKey.status" class="select-primary" filterable size="large"
                    placeholder="Status">
                    <el-option label="all" :value="null"> </el-option>
                    <el-option label="active" value="active"> </el-option>
                    <el-option label="inactive" value="inactive"> </el-option>
                  </el-select>
                </base-input>
              </div>
              <div class="col-sm-2">
                <div style="column-gap: 5px; top: 30px"></div>
                <div class="row">
                  <div style="
                      column-gap: 5px;
                      text-align: right;
                      position: absolute;
                      bottom: 5px;
                    ">
                    <base-button type="primary" @click="search" style="width: 100px">Search</base-button>
                    <base-button type="primary" @click="reset" style="width: 100px">Reset</base-button>
                  </div>
                </div>
              </div>
            </div>
            <!-- end Search part-->
            <div class="row" style="margin-top: 20px">
              <div class="col-sm-12" style="display: flex">
                <div class="col-sm-3">
                  <el-link type="primary" @click="OpenUpdateUserInfo">Add User</el-link>
                </div>
                <span style="
                    margin-left: auto;
                    line-height: 32px;
                    padding-right: 20px;
                  ">
                  <el-pagination v-model:current-page="currentPage" v-model:page-size="pageSize"
                    :page-sizes="[10, 20, 30, 50, 100]" :small="small" :background="true"
                    layout="total, sizes, prev, pager, next, jumper" :total="searchKey.total"
                    @size-change="ChangePageSearch" @current-change="ChangePageSearch" />
                </span>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-12">
                <el-table :data="userlist" style="width: 100%" border row-key="idTmp" :default-expand-all="false"
                  row-style="success-row" @filter-change="filterChange" table-layout="auto">
                  <el-table-column prop="no" label="No" :width="50" />
                  <tablecolumn prop="name" label="name" :width="160" />
                  <tablecolumn prop="departmentTeamName" label="DepartmentName-TeamName" :width="220" />
                  <tablecolumn prop="roleName" label="RoleNameList" :width="140" />
                  <tablecolumn prop="name_code" label="name_code" :width="140" />
                  <tablecolumn prop="user_name" label="user_name" :width="140" />
                  <el-table-column prop="status" label="status" :width="100" />
                  <tablecolumn prop="usersRoles_status" v-if="false" label="usersRoles_status" />
                  <tablecolumn prop="is_sales" label="is_sales" :width="100" />
                  <tablecolumn prop="teamName" v-if="false" label="TeamName" :width="140" />
                  <tablecolumn prop="teamAlias" v-if="false" label="TeamAlias" :width="160" />
                  <tablecolumn prop="teamHeadName" v-if="false" label="TeamHeadName" :width="160" />
                  <tablecolumn prop="teamHeadUserName" v-if="false" label="TeamHeadUserName" :width="160" />
                  <tablecolumn prop="groupName" v-if="false" label="GroupName" :width="140" />
                  <tablecolumn prop="groupHeadName" v-if="false" label="GroupHeadName" :width="160" />
                  <tablecolumn prop="groupHeadUserName" v-if="false" label="GroupHeadUserName" :width="160" />
                  <tablecolumn prop="departmentHeadName" v-if="false" label="DepartmentHeadName" :width="160" />
                  <tablecolumn prop="departmentHeadUserName" v-if="false" label="DepartmentHeadUserName" :width="180" />
                  <tablecolumn v-if="false" prop="business_category" label="business_category" :width="340" />

                  <tablecolumn prop="email" label="email" :width="210" />
                  <tablecolumn prop="mobile_tel" label="mobile_tel" :width="140" />
                  <tablecolumn prop="office_tel" label="office_tel" :width="140" />
                  <tablecolumn prop="job_title" label="job_title" :width="210" />
                  <tablecolumn prop="role_id" v-if="false" label="role_id" :width="250" />
                  <tablecolumn prop="teamID" v-if="false" label="TeamID" :width="250" />
                  <tablecolumn prop="teamHeadID" v-if="false" label="TeamHeadID" :width="250" />
                  <tablecolumn prop="groupID" v-if="false" label="GroupID" :width="250" />
                  <tablecolumn prop="groupHeadID" v-if="false" label="GroupHeadID" :width="250" />
                  <tablecolumn prop="departmentID" v-if="false" label="DepartmentID" :width="250" />
                  <tablecolumn prop="departmentHeadID" v-if="false" label="DepartmentHeadID" :width="250" />
                  <tablecolumn prop="remark" label="remark" :width="140" />
                  <tablecolumn prop="unit" label="unit" :width="80" />
                  <tablecolumn prop="alias" label="alias" :width="80" />
                  <el-table-column prop="created_at" label="created_at" :width="190" />
                  <el-table-column prop="created_by" label="created_by" :width="120" />
                  <el-table-column prop="updated_at" label="updated_at" :width="190" />
                  <el-table-column prop="updated_by" label="updated_by" :width="120" />
                  <tablecolumn prop="id" v-if="false" label="id" :width="250" />

                  <el-table-column prop="" fixed="right" label="action " :width="160" class-name="action">
                    <template #default="scope">
                      <el-link type="primary" @click="OpenUpdatePassword(scope.row)">Update Password</el-link>
                      <el-link type="primary" @click="OpenUpdateUserInfo(scope.row)">Update UserInfo</el-link>
                      <el-link type="primary" @click="OpenUpdateKeyAccount(scope.row)">Update KeyAccount</el-link>
                    </template>
                  </el-table-column>
                  <el-table-column v-if="false" prop="" fixed="right" label=" UsersRoles" :width="160"
                    class-name="action">
                    <template #default="scope">
                      <el-link type="primary" @click="OpenDialog(scope.row, 'AddUsersRoles')">Add UsersRoles</el-link>
                      <el-link type="primary" @click="OpenDialog(scope.row, 'UpdateUsersRoles')">Update
                        UsersRoles</el-link>
                    </template>
                  </el-table-column>
                </el-table>
                <div></div>
              </div>
            </div>
          </el-card>
        </div>
      </div>
    </div>
    <!-- 修改信息 -->
    <div>
      <el-dialog v-model="dialogFormVisibleUserInfo" title="UserInfo" width="80%">
        <el-form :model="userInfoData">
          <el-row>
            <!-- UserInfo -->
            <el-col :span="6">
              <el-card>
                <el-divider>
                  <span>UserInfo</span>
                </el-divider>

                <el-scrollbar height="620px" style="width: 100%">
                  <el-form-item label="name" :label-width="formLabelWidth">
                    <el-input v-model="userInfoData.value.name" autocomplete="off" />
                  </el-form-item>
                  <el-form-item label="name_code" :label-width="formLabelWidth">
                    <el-input v-model="userInfoData.value.name_code" autocomplete="off" />
                  </el-form-item>
                  <el-form-item label="user_name" :label-width="formLabelWidth">
                    <el-input v-model="userInfoData.value.user_name" autocomplete="off" />
                  </el-form-item>

                  <el-form-item label="status" :label-width="formLabelWidth">
                    <el-select v-model="userInfoData.value.status">
                      <el-option label="active" value="active" />
                      <el-option label="inactive" value="inactive" />
                    </el-select>
                  </el-form-item>
                  <el-form-item label="is_sales" :label-width="formLabelWidth">
                    <el-select v-model="userInfoData.value.is_sales">
                      <el-option label="true" value="true" />
                      <el-option label="false" value="false" />
                    </el-select>
                  </el-form-item>
                  <el-form-item label="email" :label-width="formLabelWidth">
                    <el-input v-model="userInfoData.value.email" autocomplete="off" />
                  </el-form-item>
                  <el-form-item label="office_tel" :label-width="formLabelWidth">
                    <el-input v-model="userInfoData.value.office_tel" autocomplete="off" />
                  </el-form-item>
                  <el-form-item label="mobile_tel" :label-width="formLabelWidth">
                    <el-input v-model="userInfoData.value.mobile_tel" autocomplete="off" />
                  </el-form-item>
                  <el-form-item label="job_title" :label-width="formLabelWidth">
                    <el-input v-model="userInfoData.value.job_title" autocomplete="off" />
                  </el-form-item>
                  <el-form-item label="remark" :label-width="formLabelWidth">
                    <el-input v-model="userInfoData.value.remark" autocomplete="off" />
                  </el-form-item>
                </el-scrollbar>
              </el-card>
            </el-col>

            <!-- Teams -->
            <el-col :span="4" style="margin-left: 10px;">
              <el-card>
                <el-divider>
                  <span>Teams</span>
                </el-divider>
                <el-form-item label="" :label-width="1">
                  <el-scrollbar height="600px" style="width: 100%">
                    <el-tree :key="Math.random()" :data="DepartmentTeamsList" show-checkbox :default-expand-all="true"
                      node-key="id" :default-checked-keys="userInfoData.value.teamIdList"
                      @check="changDepartmentTeams" />
                  </el-scrollbar>
                </el-form-item>
              </el-card>
            </el-col>
            <!-- Roles -->
            <el-col :span="4" style="margin-left: 10px;">
              <el-card>
                <el-divider>
                  <span>Roles</span>
                </el-divider>
                <el-form-item label="" :label-width="1">
                  <el-scrollbar height="600px" style="width: 100%">
                    <el-tree :key="Math.random()" :data="RolesList" show-checkbox :default-expand-all="true"
                      node-key="id" :default-checked-keys="userInfoData.value.roleIdList" @check="changRoles"
                      :props="defaultProps" />
                  </el-scrollbar>
                </el-form-item> </el-card></el-col>
            <!-- BC -->
            <el-col :span="7" style="margin-left: 10px;">
              <el-card>
                <el-divider>
                  <span>BC</span>
                </el-divider>
                <el-form-item label="" style="width: 100%" :label-width="1">
                  <el-scrollbar height="600px" style="width: 100%">
                    <!-- <el-tree
                      :key="Math.random()"
                      :data="BUList"
                      show-checkbox
                      :default-expand-all="true"
                      node-key="id"
                      :default-checked-keys="
                        userInfoData.value.business_categoryList
                      "
                      @check="changBC"
                    /> -->

                    <base-input label="" style="width: 100%">
                      <el-select v-model="userInfoData.value.business_categoryList" class="select-primary" size="large"
                        multiple filterable style="width: 100%" placeholder="" @change="changBC">
                        <el-option v-for="item in BUList" :label="item.label" :value="item.id" :key="item.id">
                        </el-option>
                      </el-select>
                    </base-input>
                  </el-scrollbar>
                </el-form-item> </el-card></el-col>

          </el-row>
        

        </el-form>

        <template #footer>
          <span class="dialog-footer">
            <el-button @click="dialogFormVisibleUserInfo = false">Cancel</el-button>
            <el-button type="primary" @click="UpdateUserInfo">
              Confirm
            </el-button>
          </span>
        </template>
      </el-dialog>
    </div>
    <!-- KeyAccount -->
    <div>
      <el-dialog v-model="dialogFormVisibleKeyAccount" title="KeyAccount" width="60%">
        <el-form :model="userInfoData">
          <el-row>
            <!-- KeyAccount -->
            <el-col :span="7" style="margin-left: 10px;">
              <el-card>
                <el-divider>
                  <span>KeyAccount(BB)</span>
                </el-divider>
                <el-form-item label="" style="width: 100%" :label-width="1">
                  <el-scrollbar height="600px" style="width: 100%">
                    <base-input label="" style="width: 100%">
                      <el-select v-model="userInfoData.value.key_company_idListBB" class="select-primary" size="large"
                        multiple filterable style="width: 100%" placeholder="">
                        <el-option v-for="item in CRMList" :label="item.label" :value="item.id" :key="item.id">
                        </el-option>
                      </el-select>
                    </base-input>
                  </el-scrollbar>
                </el-form-item> </el-card></el-col>
            <!-- KeyAccount -->
            <el-col :span="7" style="margin-left: 10px;">
              <el-card>
                <el-divider>
                  <span>KeyAccount(Bus)</span>
                </el-divider>
                <el-form-item label="" style="width: 100%" :label-width="1">
                  <el-scrollbar height="600px" style="width: 100%">
                    <base-input label="" style="width: 100%">
                      <el-select v-model="userInfoData.value.key_company_idListBus" class="select-primary" size="large"
                        multiple filterable style="width: 100%" placeholder="">
                        <el-option v-for="item in CRMList" :label="item.label" :value="item.id" :key="item.id">
                        </el-option>
                      </el-select>
                    </base-input>
                  </el-scrollbar>
                </el-form-item> </el-card></el-col>
            <!-- KeyAccount -->
            <el-col :span="7" style="margin-left: 10px;">
              <el-card>
                <el-divider>
                  <span>KeyAccount(MTR)</span>
                </el-divider>
                <el-form-item label="" style="width: 100%" :label-width="1">
                  <el-scrollbar height="600px" style="width: 100%">
                    <base-input label="" style="width: 100%">
                      <el-select v-model="userInfoData.value.key_company_idListMTR" class="select-primary" size="large"
                        multiple filterable style="width: 100%" placeholder="">
                        <el-option v-for="item in CRMList" :label="item.label" :value="item.id" :key="item.id">
                        </el-option>
                      </el-select>
                    </base-input>
                  </el-scrollbar>
                </el-form-item> </el-card></el-col>
          </el-row>

        </el-form>

        <template #footer>
          <span class="dialog-footer">
            <el-button @click="dialogFormVisibleKeyAccount = false">Cancel</el-button>
            <el-button type="primary" @click="UpdateKeyAccount">
              Confirm
            </el-button>
          </span>
        </template>
      </el-dialog>
    </div>
    <!-- 修改密码 -->
    <div>
      <el-dialog v-model="dialogFormVisible" title="Update Password" :width="800">
        <el-form :model="userInfoData">
          <el-form-item label="user_name" :label-width="formLabelWidth">
            <el-input disabled v-model="userInfoData.value.user_name" autocomplete="off" />
          </el-form-item>
          <el-form-item label="Password" :label-width="formLabelWidth">
            <el-input v-model="userInfoData.value.password" autocomplete="off" />
          </el-form-item>
        </el-form>
        <template #footer>
          <span class="dialog-footer">
            <el-button @click="dialogFormVisible = false">Cancel</el-button>
            <el-button type="primary" @click="UpdatePassword">
              Confirm
            </el-button>
          </span>
        </template>
      </el-dialog>
    </div>

    <!-- 添加用户角色 -->
    <div>
      <el-dialog v-model="dialogUsersRoles" title="Add UsersRoles" :width="800">
        <el-form :model="userInfoData">
          <el-form-item label="user_name" :label-width="formLabelWidth">
            <el-input disabled v-model="userInfoData.value.user_name" autocomplete="off" />
          </el-form-item>
          <el-form-item label="RoleName" :label-width="formLabelWidth" required>
            <el-select :disabled="AddUpdateType == 'UpdateUsersRoles'" v-model="userInfoData.value.roleName">
              <el-option v-for="item in RolesList" :value="item.name" :label="item.name" :key="item.name"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="UsersRoles Status" :label-width="formLabelWidth" required>
            <el-select v-model="userInfoData.value.usersRoles_status">
              <el-option label="active" value="active" />
              <el-option label="inactive" value="inactive" />
            </el-select>
          </el-form-item>
        </el-form>
        <template #footer>
          <span class="dialog-footer">
            <el-button @click="dialogUsersRoles = false">Cancel</el-button>
            <el-button type="primary" @click="AddUpdateUsersRoles">
              Confirm
            </el-button>
          </span>
        </template>
      </el-dialog>
    </div>
  </el-tab-pane>
</template>

<script setup>
// import './css/index.css';
import { watch, ref, reactive, onBeforeMount, onMounted } from 'vue';
import baseInput from '@/components/newUI/Inputs/BaseInput';
import baseButton from '@/components/newUI/BaseButton';
import basePagination from '@/components/newUI/BasePagination';
import tablecolumn from '@/components/tablecolumn';
import PubSub from 'pubsub-js';
import TeamsManage from './teamsManage.vue';
import FunctionsManage from './functionsManage.vue';
import RolesManage from './rolesManage.vue';
const currentPage = ref(1);
const pageSize = ref(10);
const formLabelWidth = '100px';
const tabkey = ref('UserManage');

// router
import router from '@/router';
import profile from '@/network/profile';

// icon
import { Edit, Search } from '@element-plus/icons-vue';
import { ElMessage } from 'element-plus';

// tool
import {
  formatterCellMoney,
  formatterCellDate,
  formatterCellDateTime,
} from '@/assets/js/formatter';
import { el } from 'element-plus/es/locale';
onBeforeMount(async () => {
  await search();
});

// #region UserManage
const dialogFormVisible = ref(false);
const dialogFormVisibleUserInfo = ref(false);
const dialogFormVisibleKeyAccount = ref(false);
const dialogUsersRoles = ref(false);
const userInfoData = reactive({});
const RolesList = ref({});
const DepartmentTeamsList = ref({});
const BUList = ref({});
const userlist = ref([]);
const CRMList = ref({});

const defaultProps = {
  children: 'children',
  label: 'name',
};
//更改用户所属组
const changDepartmentTeams = (data, data1) => {
  userInfoData.value.teamIdList = data1.checkedKeys;
};
//更改用户角色
const changRoles = (data, data1) => {
  userInfoData.value.roleIdList = data1.checkedKeys;
};
// //更改用户BC
// const changBC = (data, data1) => {
//   userInfoData.value.business_categoryList = data1.checkedKeys;
// };
const handleMouseEnter = (row, column, cell) => {
  if (row.id === 1) {
    this.$refs.table.toggleRowClass(row, 'custom-row');
  } else {
    this.$refs.table.removeRowClass(row, 'custom-row');
  }
};

//变更分页
const ChangePageSearch = async (data) => {
  searchKey.pageIndex = currentPage;
  searchKey.pageSize = pageSize;
  search();
};

//搜索条件实体
const searchKey = reactive({
  pageIndex: 1,
  pageSize: 10,
  status: 'active',
});
// event: Search
const search = async () => {
  const search_res = await profile.GetUserList2(searchKey).then((res) => res);
  searchKey.total = search_res.data.total;
  userlist.value = search_res.data.list;
  RolesList.value = search_res.data.rolesList;
  DepartmentTeamsList.value = search_res.data.departmentTeamsList;
  BUList.value = search_res.data.buList;
  CRMList.value = search_res.data.crmList;

};

const AddUpdateType = ref('');
//打开
const OpenDialog = async (data, typeName) => {
  AddUpdateType.value = typeName;
  if (AddUpdateType.value == 'AddUsersRoles') {
    dialogUsersRoles.value = true;
    userInfoData.value = JSON.parse(JSON.stringify(data));
    userInfoData.value.roleName = '';
    userInfoData.value.usersRoles_id = '';
  } else if (AddUpdateType.value == 'UpdateUsersRoles') {
    dialogUsersRoles.value = true;
    userInfoData.value = JSON.parse(JSON.stringify(data));
  }
};
//添加修改用户权限
const AddUpdateUsersRoles = async (data) => {
  dialogUsersRoles.value = false;
  if (AddUpdateType.value == 'AddUsersRoles') {
    const result = await profile
      .AddUsersRoles(userInfoData.value)
      .then((res) => res);
    if (result.data === '') {
      ElMessage({
        message: '添加成功',
        type: 'success',
      });
    } else {
      ElMessage({
        message: result.data,
        type: 'warning',
      });
    }
  } else if (AddUpdateType.value == 'UpdateUsersRoles') {
    const result = await profile
      .UpdateUsersRoles(userInfoData.value)
      .then((res) => res);
    if (result.data === '') {
      ElMessage({
        message: '修改成功',
        type: 'success',
      });
    } else {
      ElMessage({
        message: result.data,
        type: 'warning',
      });
    }
  }

  await search();
};

//打开修改密码
const OpenUpdatePassword = async (data) => {
  dialogFormVisible.value = true;
  userInfoData.value = data;
};
//修改密码
const UpdatePassword = async (data) => {
  dialogFormVisible.value = false;
  const result = await profile
    .UpdateUserPassword(userInfoData.value)
    .then((res) => res);
  if (result.data === '') {
    ElMessage({
      message: '修改成功',
      type: 'success',
    });
  } else {
    ElMessage({
      message: result.data,
      type: 'warning',
    });
  }
  await search();
};
//打开添加用户
const OpenAddUserInfo = async () => {
  //清空对象
  Object.keys(userInfoData).map((key) => {
    delete userInfoData[key];
  });
  dialogFormVisibleUserInfo.value = true;
};
//打开修改信息
const OpenUpdateUserInfo = async (data) => {
  userInfoData.value = JSON.parse(JSON.stringify(data));
  dialogFormVisibleUserInfo.value = true;
};
//打开修改KeyAccount
const OpenUpdateKeyAccount = async (data) => {
  userInfoData.value = JSON.parse(JSON.stringify(data));
  dialogFormVisibleKeyAccount.value = true;
};
//修改信息
const UpdateUserInfo = async (data) => {
  dialogFormVisibleUserInfo.value = false;
  const result = await profile
    .UpdateUserInfo(userInfoData.value)
    .then((res) => res);
  if (result.data === '') {
    ElMessage({
      message: '修改成功',
      type: 'success',
    });
  } else {
    ElMessage({
      message: result.data,
      type: 'warning',
    });
  }
  await search();
};
//修改KeyAccount
const UpdateKeyAccount = async (data) => {
  dialogFormVisibleKeyAccount.value = false;
  const result = await profile
    .UpdateKeyAccount(userInfoData.value)
    .then((res) => res);
  if (result.data === '') {
    ElMessage({
      message: '修改成功',
      type: 'success',
    });
  } else {
    ElMessage({
      message: result.data,
      type: 'warning',
    });
  }
  await search();
};
//重置筛选条件
const reset = async () => {
  //清空对象
  Object.keys(searchKey).map((key) => {
    delete searchKey[key];
  });
  searchKey.pageIndex = 1;
  searchKey.pageSize = 10;
  searchKey.status = 'active';

  search();
};

const filterChange = async (filters) => {
  await search();
};
// #endregion

//组件传值
onMounted(async () => {
  PubSub.subscribe('mode', (name, data) => {
    // 动态赋值
    searchKey[`${data.key}`] = data.value;
    search();
  });
});

const TabClick = (data) => {
  tabkey.value = data.props.label;
  console.log(data.props.label);
};
</script>

<style scoped>
.my-class .el-input__inner {
  color: blue;
  /* 字体颜色 */
}

.el-button--text {
  margin-right: 15px;
}

.el-select {
  width: 300px;
}

.el-input {
  width: 300px;
}

.dialog-footer button:first-child {
  margin-right: 10px;
}
</style>

<style>
.el-table .warning-row {
  --el-table-tr-bg-color: var(--el-color-warning-light-9);
}

.el-table .success-row {
  --el-table-tr-bg-color: var(--el-color-success-light-9);
}

.row-red {
  background-color: red;
}

.row-blue {
  background-color: blue;
}

.row-green {
  background-color: green;
}
</style>
<style scoped>
.el-table .warning-row {
  --el-table-tr-bg-color: var(--el-color-warning-light-9);
}

.el-table .success-row {
  --el-table-tr-bg-color: var(--el-color-success-light-9);
}
</style>
